"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _SIAMember = _interopRequireDefault(require("./SIAMember"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
(function () {
  const styles = ":export {\n  primary-SIAblack: #000000;\n  primary-SIAgraydark: #4c4c4c;\n  primary-SIAgrayMiddle: #a8a8a8;\n  primary-SIAgray: #d4d4d4;\n  primary-SIAgrayLight: #e8e8e8;\n  primary-SIAgrayVeryLight: #f4f4f4;\n  primary-SIAwhite: #fff;\n  primary-SIAred: #e41b13;\n  primary-SIAredDark: #99100a;\n  secondary-SIAazure: #8caddb;\n  secondary-SIAazureLight: #e9eff7;\n  secondary-SIAbronze: #b1997e;\n  secondary-SIAbronzeLight: #efebe5;\n  secondary-SIAgreen: #2fb789;\n  secondary-SIAgreenLight: #ecf7f3;\n  secondary-SIAorange: #f3743d;\n  secondary-SIAorangeLight: #fbf1ec;\n  secondary-SIArose: #e6005f;\n  secondary-SIAroseLight: #fcf2f7;\n  secondary-SIAyellow: #dacd7e;\n  secondary-SIAyellowLight: #faf8ed; }\n\n.DirectoryPreviews .DirectoryPreviews-container .bottom-section {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  width: 100%;\n  justify-content: flex-start;\n  column-gap: 16px; }\n\n.DirectoryPreviews .DirectoryPreviews-container .info-container {\n  margin-left: 0px; }\n\n@media (max-width: 66rem) {\n  .DirectoryPreviews .DirectoryPreviews-container .bottom-section {\n    grid-template-columns: repeat(3, 1fr); }\n  .DirectoryPreviews .DirectoryPreviews-container .info-container {\n    width: 100%;\n    max-width: 312px; } }\n\n@media (max-width: 42rem) {\n  .DirectoryPreviews .DirectoryPreviews-container .bottom-section {\n    grid-template-columns: repeat(2, 1fr); }\n  .DirectoryPreviews .DirectoryPreviews-container .info-container {\n    width: 100%;\n    max-width: 288px; } }\n";
  const fileName = "DirectoryPreviews_DirectoryPreviews";
  const element = document.querySelector("style[data-sass-component='DirectoryPreviews_DirectoryPreviews']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
const DirectoryPreviews = _ref => {
  let {
    members,
    title,
    elementToRender
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "DirectoryPreviews"
  }, title && /*#__PURE__*/_react.default.createElement("div", {
    className: "DirectoryPreviews-Title sia-margin-03-bottom sia-padding-03-bottom sia-border-01-bottom"
  }, /*#__PURE__*/_react.default.createElement("p", null, title)), /*#__PURE__*/_react.default.createElement("div", {
    className: "DirectoryPreviews-container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "bottom-section"
  }, members.map(member => {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "employee",
      key: member.url
    }, /*#__PURE__*/_react.default.createElement(_SIAMember.default, _extends({}, member, {
      Component: elementToRender
    })));
  }))));
};
DirectoryPreviews.propTypes = {
  members: _propTypes.default.arrayOf(_propTypes.default.shape({
    firstname: _propTypes.default.string.isRequired,
    lastname: _propTypes.default.string.isRequired,
    url: _propTypes.default.string.isRequired,
    picture: _propTypes.default.string,
    city: _propTypes.default.string,
    academic_title: _propTypes.default.string,
    member_type: _propTypes.default.string,
    quinaryTags: _propTypes.default.array,
    quaternaryTags: _propTypes.default.array,
    tertiaryTags: _propTypes.default.array
  })).isRequired,
  title: _propTypes.default.string,
  elementToRender: _propTypes.default.elementType.isRequired
};
var _default = exports.default = DirectoryPreviews;